import { makeAutoObservable } from 'mobx'
import { SendLaterStore } from 'shared/ui/Schedule/ui/SendLater'
import { ScheduleDelayStore } from 'shared/ui/Schedule/ui/ScheduleDelay'
import { uiStore } from 'shared/store/uiStore'
import { type ICampaignSchedule, type ICampaignScheduleType } from 'entities/Campaign'
import { type CustomField } from 'entities/CustomField'
import { ScheduleDateFiledStore } from './scheduleDateFiledStore'

export class CampaignScheduleStore {
  scheduleDelayStore
  sendLaterStore
  scheduleDateFiledStore
  constructor() {
    this.scheduleDelayStore = new ScheduleDelayStore()
    this.sendLaterStore = new SendLaterStore({
      withAdvancedScheduling: false,
    })
    this.scheduleDateFiledStore = new ScheduleDateFiledStore()
    makeAutoObservable(this)
  }

  get params(): ICampaignSchedule | null {
    if (this.scheduleType === 'immediately') {
      return {
        type: 'immediately',
        options: null,
      }
    }
    if (this.scheduleType === 'delay') {
      return {
        type: 'delay',
        options: this.scheduleDelayStore.params,
      }
    }
    if (this.scheduleType === 'date') {
      return {
        type: 'date',
        options: {
          date: this.sendLaterStore.utcDateString,
          use_contact_timezone: this.sendLaterStore.isUseContactTimezone,
        },
      }
    }
    if (this.scheduleType === 'date_field') {
      return {
        type: 'date_field',
        options: this.scheduleDateFiledStore.params,
      }
    }
    return null
  }

  init = (params: typeof this.params, dateField: CustomField | null, default_timezone?: string) => {
    if (!params) {
      return
    }
    this.scheduleType = params.type
    if (params.type === 'delay') {
      this.scheduleDelayStore.init({
        unit: params.options?.unit,
        value: params.options.value,
      })
    }
    if (params.type === 'date') {
      this.sendLaterStore.init({
        date: params.options.date,
        isUseContactTimezone: params.options.use_contact_timezone,
      })
    }
    if (params.type === 'date_field') {
      this.scheduleDateFiledStore.init({
        ...params.options,
        default_timezone: default_timezone || uiStore.timezone,
        dateField,
      })
    }
  }

  scheduleType: ICampaignScheduleType = 'immediately'
  setScheduleType = (value: ICampaignScheduleType) => {
    this.scheduleType = value
  }
  get scheduleText() {
    if (this.scheduleType === 'immediately') {
      return 'Immediately'
    }
    if (this.scheduleType === 'delay') {
      return `${this.scheduleDelayStore.scheduleText} later`
    }
    if (this.scheduleType === 'date') {
      return this.sendLaterStore.scheduleText
    }
    if (this.scheduleType === 'date_field') {
      return this.scheduleDateFiledStore.scheduleText
    }
    return ''
  }

  get is_contact_timezone() {
    if (this.scheduleType === 'date') {
      return this.sendLaterStore.isUseContactTimezone
    }

    if (this.scheduleType === 'date_field') {
      return this.scheduleDateFiledStore.isUseContactTimezone
    }

    return null
  }
}
